import { EntityLinks, GroupSetting } from '@griply/types';
import { createContext, useContext } from 'react';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';
import { Task } from 'shared/types/task';

export type GoalRenderData = {
  groupSettings: GroupSetting;
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  goals: Goal[];
  lifeAreas: LifeArea[];
  links: EntityLinks;
  today: Date;
  denseFormat?: boolean;
  defaultNewTaskDate?: Date;
};

export const GoalRenderDataContext = createContext<GoalRenderData | null>(null);

export const useGoalRenderData = (): GoalRenderData => {
  const data = useContext(GoalRenderDataContext);
  if (!data) {
    throw new Error(
      'useGoalRenderData must be used within a GoalGroupingTasksList',
    );
  }
  return data;
};
